import { string2Color } from '@models/utils/colors';
import { BaseSystemModel, Guid, RecursivePartial } from '@models/base';

export interface IProjectTpl {
    name?: string;
    abbr?: string;
    avatar?: string;
    orgId?: Guid;
    groupIds?: Guid[];
    personIds?: Guid[];
    managerId?: Guid;
    templateId?: Guid;
}

export class Project extends BaseSystemModel {
    _type = BaseSystemModel.Type.Project;

    name!: string;
    abbr!: string;
    managerId!: Guid;
    avatar?: string;
    orgId!: Guid;
    closed?: boolean;
    deleted?: boolean;
    groupIds: Guid[] = [];
    personIds: Guid[] = [];
    taskTypeIds: Guid[] = [];

    _color!: string;

    constructor(json?: RecursivePartial<Project>) {
        super(json);
        this.parseProject(json || {});
    }

    parse(json: RecursivePartial<Project>): Project {
        super.parse(json);
        this.parseProject(json);
        return this;
    }

    private parseProject(json: RecursivePartial<Project>): void {
        Project.assignFields<Project>(this, json, ['name', 'abbr', 'managerId', 'avatar', 'orgId', 'closed', 'deleted', 'groupIds', 'personIds', 'taskTypeIds']);
        this._color = string2Color(this.id);
    }
}
